"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToastService = /** @class */ (function () {
    function ToastService() {
    }
    ToastService.prototype.showMessage = function (message, time) {
        Materialize.Toast.removeAll();
        Materialize.toast(message, 4000);
    };
    ToastService.ctorParameters = function () { return []; };
    return ToastService;
}());
exports.ToastService = ToastService;
//# sourceMappingURL=toast.service.js.map


// WEBPACK FOOTER //
// toast.service.js